import { useEffect, useState } from "react";

type OpacityMap = Record<`step${number}`, number>;

export function useStaggeredOpacity(
  stepCount: number,
  delayPerStep: number = 500
): OpacityMap {
  const initialState: OpacityMap = Object.fromEntries(
    Array.from({ length: stepCount }, (_, index) => [`step${index + 1}`, 0])
  ) as OpacityMap;

  const [opacity, setOpacity] = useState<OpacityMap>(initialState);

  useEffect(() => {
    const timers: NodeJS.Timeout[] = Array.from({ length: stepCount }).map(
      (_, index) =>
        setTimeout(() => {
          setOpacity((prev) => ({
            ...prev,
            [`step${index + 1}`]: 1,
          }));
        }, delayPerStep * (index + 1))
    );

    return () => {
      timers.forEach(clearTimeout);
    };
  }, [stepCount, delayPerStep]);

  return opacity;
}
